import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface OrganizationScopedDevice {
  device_id: string;
  device_name: string | null;
  device_description?: string | null;
  device_serial?: string | null;
}

/**
 * Devices that belong to a specific organization (by device_details.organization_id).
 * Used when granting device access to a contact/user of that organization.
 */
export const useDevicesForOrganization = (organizationId: string | undefined) => {
  return useQuery({
    queryKey: ['devices-for-organization', organizationId],
    queryFn: async (): Promise<OrganizationScopedDevice[]> => {
      if (!organizationId) return [];

      const { data, error } = await supabase
        .from('device_details')
        .select('device_id, device_name, device_description, device_serial')
        .eq('organization_id', organizationId)
        .order('device_name');

      if (error) {
        console.error('Error fetching organization devices:', error);
        throw error;
      }

      return data || [];
    },
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000,
  });
};
